module.exports = __webpack_public_path__ + "static/media/group_copy_2.9892083d.png";